module.exports = "/_next/static/images/discount_icon-e7b1eb80a656c7972afa32ee7de6f160.svg";